module.exports = __webpack_public_path__ + "static/monei_pay_form_en-9481e848b4bb0ac1200fcfed17b684b8.png";